<partial-loading-indicator class="dex-lp-details-w_loading-indicator">

    <div class="dex-lp-details-w_top-row" (click)="onClickToggleCollapsed($event)">
        <div class="dex-lp-details-w_top-row-col1">
            <div class="dex-lp-details-w_title">
                Liquidity Pool
            </div>
            <div class="dex-lp-details-w_tranches-count">
                <!-- Hidden as per UAT early feedback -->
                <!--@if (isFeatureEmbedded()) {
                    <svg class="dex-lp-details-w_tranches-count-toggle"
                         [class.-collapsed]="isFeatureCollapsed()"
                        (click)="onClickToggleCollapsed($event)">
                        <use xlink:href="#chevron-down"></use>
                    </svg>
                }-->
                <div class="dex-lp-details-w_tranches-count-value">
                    {{tranches().length}} Products
                </div>
            </div>
            @if (!isEmbedded()) {
                <div class="dex-lp-details-w_tranches-links">
                    @for (tranche of tranches(); track tranche.raw.poolTrancheId) {
                        <div class="dex-lp-details-w_tranches-links_item"
                             [class.-clickable]="isSymbolClickable()"
                             (click)="onSymbolClick(tranche.unitDeliverable.symbol, $event)">
                            {{tranche.unitDeliverable.symbol}}
                        </div>
                    }
                </div>
            }
        </div>

        <div class="dex-lp-details-w_top-row-col2">
            <div class="dex-lp-details-w_total-stats">
                <div class="dex-lp-details-w_total-stats-field">
                    <label class="dex-lp-details-w_total-stats-field-label">
                        Portfolio Value
                        <span class="dex-lp-details-w_total-stats-field-label-i">ⓘ</span>
                    </label>
                    <div class="dex-lp-details-w_total-stats-field-value">
                        @if (lp()?.$portfolioValueDeliverable()) {
                            <span [displayDecimal]="lp().$portfolioValue() | bigintDeliverableDisplayDecimal:lp().$portfolioValueDeliverable()"></span>
                        } @else {
                            <span></span>
                        }
                    </div>
                </div>
                <div class="dex-lp-details-w_total-stats-field">
                    <label class="dex-lp-details-w_total-stats-field-label">
                        Total Value Locked
                    </label>
                    <div class="dex-lp-details-w_total-stats-field-value">
                        @if (lp()?.$totalValueLockedDeliverable()) {
                            <span [displayDecimal]="lp().$totalValueLocked() | bigintDeliverableDisplayDecimal:lp().$totalValueLockedDeliverable()"></span>
                        } @else {
                            <span></span>
                        }
                    </div>
                </div>
            </div>
            <div class="dex-lp-details-w_pnl">
                <div class="dex-lp-details-w_pnl-field">
                    <label class="dex-lp-details-w_pnl-field-label">
                        PnL
                    </label>
                    <div class="dex-lp-details-w_pnl-field-value">
                        @if (lp()) {
                            <span [displayDecimal]="lp().$uPnlPercent()" [decimalCount]="2" [noTrailingDecimalZeroes]="true" currency="%"></span>
                            <span class="dex-lp-details-w_pnl-field-value-i"> ⓘ</span>
                        } @else {
                            <span></span>
                        }
                    </div>
                </div>
                <div class="dex-lp-details-w_pnl-chart">
                    <sparkline
                        [width]="149"
                        [height]="40"
                        [strokeWidth]="1"
                        [data]="$safeNavigationMigration(lp()?.raw) | dexTrancheSparkline:true | async"
                        [tick]="$safeNavigationMigration(lp()?.$uPnlNumber())"
                        [gradientOpacity]="0.5"
                        [tooltip]="debugSparklineTooltip()">
                    </sparkline>
                </div>
            </div>
        </div>

        <!-- TODO: Initially not shown - No positions until trading -->
        <!--<div class="dex-lp-details-w_top-row-col3">
            <div class="dex-lp-details-w_u-portfolio-field">
                <label class="dex-lp-details-w_u-portfolio-field-label">
                    Your Portfolio
                </label>
                <div class="dex-lp-details-w_u-portfolio-field-value">
                    <span [displayDecimal]="lpMock.userPortfolio | bigintDisplayDecimal:2:'USD'"></span>
                </div>
            </div>
            <div class="dex-lp-details-w_u-pnl-field">
                <label class="dex-lp-details-w_u-pnl-field-label">
                    Your PnL
                    <span class="dex-lp-details-w_u-pnl-field-label-change">
                        <span [displayDecimal]="lpMock.userPnlPercent" [decimalCount]="2" [noTrailingDecimalZeroes]="true" currency="%"></span>
                    </span>
                </label>
                <div class="dex-lp-details-w_u-pnl-field-value">
                    <span [displayDecimal]="lpMock.userPnl | bigintDisplayDecimal:2:'USD'"></span>
                </div>
            </div>
        </div>-->
    </div>

    @if (!isCollapsed()) {
        <dex-lp-details-table class="dex-lp-details-w_table"></dex-lp-details-table>
    }

</partial-loading-indicator>
